const map = {
	"./Melancolique.png": 3354,
	"./bougeote.png": 2305,
	"./confus.png": 2211,
	"./curieux.png": 7354,
	"./detendu.png": 8634,
	"./energique.png": 9430,
	"./enerve.png": 9662,
	"./enerver.png": 4750,
	"./euphorique.png": 5172,
	"./exaspere.png": 6920,
	"./excite.png": 595,
	"./farceur.png": 2023,
	"./fatigue.png": 9354,
	"./frustre.png": 5906,
	"./gastro.png": 6469,
	"./grelotant.png": 8869,
	"./irrite.png": 7214,
	"./joyeux.png": 2285,
	"./malade.png": 47,
	"./malicieux.png": 349,
	"./motive.png": 7523,
	"./optimiste.png": 9557,
	"./panique.png": 160,
	"./pensif.png": 8568,
	"./reconnaissant.png": 9585,
	"./serein.png": 6059,
	"./solitaire.png": 869,
	"./stresse.png": 3636
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4322;